import { Component, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { MdPaginator, MdSnackBar } from "@angular/material";
import { DataSource } from "@angular/cdk/collections";
import { IncassoListItemModel } from "../../models/incassi/incasso-list-item.model";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { BrogliacciService } from './../../services/brogliacci.service';
import { IncassiService } from "../../services/incassi.service";
import { DizionarioModel } from "../../models/shared/dizionario.model";
import { BrogliaccioDistintaModel } from "../../models/brogliacci/brogliaccio-distinta.model";
import { IncassoModel } from "../../models/incassi/incasso.model";
import { Router } from "@angular/router";
import { Configurations } from "../../core/configurations";
import { ZoneDataSource } from '../utenti/zone-utente-list.component';
import { AuthGuardService } from '../../services/auth-guard.service';
import { UltimaVersioneApplicativoClientService } from '../../services/ultima-versione-applicativo-client.service';


@Component({
  selector: 'app-brogliaccio-new-detail',
  templateUrl: './brogliaccio-new-detail.component.html',
  styleUrls: ['./brogliaccio-new-detail.component.css']
})

export class BrogliaccioNewDetailComponent implements OnInit {
  //nuovo brogliaccio
  brogliaccioCorrente = new BrogliaccioDistintaModel();
  //elementi per la tabella incassi
  displayedColumns = ['idIncasso', 'zona', 'clienteRagioneSociale', 'dataIncasso', 
  'totaleValuta', 'totaleAssegni', 'totale', 'includi','elimina'];
  dataSource: IncassiDaRendicontare | null;
  zoneDisplayedColumns = ['nomeZona', 'totale'];
  dataSourceZone:DataSourceZone | null;
  isAllInclusive = new BehaviorSubject<boolean>(false);
  //salvataggio
  saving: boolean;  //disabilitazione momentanea durante il salvataggio
  incassiSelezionati: string[];
  isLoading: boolean = false;
  showZoneTotal:boolean=false;
  showEliminaIncasso:boolean=false;
  zoneIncassiTotale:number[] =[];
  constructor(
    private configuration: Configurations,
    private _incassiService: IncassiService,
    private _brogliacciService: BrogliacciService,
    private authGuardService:AuthGuardService,
    private snackBar: MdSnackBar,
    private _ultimaVersioneClientTipo:UltimaVersioneApplicativoClientService,
    private router: Router) { }

  @ViewChild(MdPaginator) paginator: MdPaginator;

  fixedSum(a:number,b:number,inverse:boolean):number {
    if(!inverse) {
      return Math.round((a + b)*1e12)/1e12;
    } else {
      return Math.round((a - b)*1e12)/1e12;
    }
  }
  showZoneTotalOn() {
    this.showZoneTotal=true;
  }
  showZoneTotalOff() {
    this.showZoneTotal=false;
  }
  eliminaIncasso(ev,incasso) {
    if(confirm("Eliminare l'incasso confermato?")) {
      this.isLoading=true;
      this._incassiService.delete(incasso).subscribe(()=> {
        this.showInfo("Incasso eliminato correttamente");
        this.caricaIncassiDaRendicontare();

      },
      error=> {
        this.showError("Errore all'eliminazione dell'incasso");
      }
      );
    }
  }
  caricaIncassiDaRendicontare() {
    let main =this;
    this._incassiService.getListDaRendicontare()
    .catch((r: Response, o) => {
      return Observable.throw(r);
    })
    .subscribe((r: IncassoModel[]) => {
      this.dataSource = new IncassiDaRendicontare(r, null);
      this.isLoading = false;
      let zoneTotali:any[]=[];
      this.zoneIncassiTotale=[];
      r.map(function(inc){

        if(main.zoneIncassiTotale[inc.zona]) {
          main.zoneIncassiTotale[inc.zona] =
            main.fixedSum(main.zoneIncassiTotale[inc.zona],inc.totaleIncasso!==null?inc.totaleIncasso:0,false);
        } else {
          main.zoneIncassiTotale[inc.zona] = (inc.totaleIncasso!==null?inc.totaleIncasso:0);
        }
      });
      for(let z in this.zoneIncassiTotale) {
        if(z) {
          zoneTotali.push({nomeZona:z, totale:this.zoneIncassiTotale[z]});
        }
      }
      this.dataSourceZone=new DataSourceZone(zoneTotali);
    },
      error => {
        this.isLoading = false;
        this.showError("Errore durante il caricamento dei dati");
        return false;
      }
    );
  }
  ngOnInit() {
    let main =this;
    //alert("pagina dettaglio brogliacci");
    this._ultimaVersioneClientTipo.getUltimaVersioneApplicativo()
    .subscribe(data => {
      Configurations.currentVersionCod=data.codice;
      let v=localStorage.getItem('clientVersion');
      if(v===null||v===undefined||v!==data.codice) {
        localStorage.setItem('clientVersion',data.codice);
        alert("Sono state pubblicate delle modifiche nel portale, per poterle caricare verrà indirizzato alla homepage.");
        window.location.href=Configurations.baseUrl;
        
      }
    });
    this.isLoading = true;
    this.showEliminaIncasso=
      this.authGuardService.checkPermission("Ispettore")||
      this.authGuardService.checkPermission("Supervisore")||
      this.authGuardService.checkPermission("AdministratorAgentiweb")||
      this.authGuardService.checkPermission("Administrator")||
      this.authGuardService.checkPermission("Procuratore");
    //carica lista incassi da rendicontare
      this.caricaIncassiDaRendicontare();
  }
  /* CALCOLA TOTALI */
  getTotal(): number {
    let tot = 0;
    if (this.dataSource && this.dataSource.incassi) {

      this.dataSource.incassi.subscribe(d => d.forEach(i => {
        if (!isNaN(i.totaleIncasso) && i.statoIncasso.id === 4) {
          tot += i.totaleIncasso;
        }
      }));
      this.brogliaccioCorrente.totale = tot;
      //if(tot>0)
      //  this.canSave= true;
      //else this.canSave= false;
    }
    return tot;
  }
  getTotalAssegni(): number {
    let tot = 0;
    if (this.dataSource && this.dataSource.incassi) {
      this.dataSource.incassi.subscribe(d =>
        d.forEach(i => {
          if (!isNaN(i.totaleAssegni) && i.statoIncasso.id === 4) {
            tot += i.totaleAssegni;
          }
        }));
      this.brogliaccioCorrente.totaleAssegni = tot;
    }
    return tot;
  }
  getTotalContanti(): number {
    let tot = 0;
    if (this.dataSource && this.dataSource.incassi) {
      this.dataSource.incassi.subscribe(d => d.forEach(i => {
        if (!isNaN(i.totaleValuta) && i.statoIncasso.id === 4) {
          tot += i.totaleValuta;
        }
      }));
      this.brogliaccioCorrente.totaleValuta = tot;
    }
    return tot;
  }

  /* COMANDI CHECK */
  includi(ev, row: IncassoModel) {
    let target = ev.target;
    // if (row.statoIncasso.id === 4) {
    //   row.statoIncasso.id = 3;
    // } else {
    //   row.statoIncasso.id = 4;
    // }
    if (target.checked) {
      row.statoIncasso.id = 4;
    } else {
      row.statoIncasso.id = 3;
    }
    console.log(row.statoIncasso.id);
  }
  includiTutto(e) {
    if (this.dataSource.incassi) {
      this.dataSource.incassi.subscribe(d => d.forEach(i => {
        i.statoIncasso.id = e.target.checked ? 4 : 3;
      }));
      this.isAllInclusive.next(e.target.checked);
    }
  }

  /* SALVATAGGIO */
  creaBrogliaccio(): void {

    if (this.brogliaccioCorrente.totale === 0) {
      this.showError("Errore. Selezionare almeno un incasso");
    } else {
      this.saving = true;
      this.brogliaccioCorrente.incassi = [];

      if (this.dataSource.incassi) {
        this.dataSource.incassi.subscribe(d => d.forEach(inc => {
          if (inc.statoIncasso.id === 4) {
            //4= archiviato: collegato a brogliaccio
            this.brogliaccioCorrente.incassi.push(inc);
            inc.statoIncasso.id = 4;
            this._incassiService.update(inc);
          }
        }));
        this.brogliaccioCorrente.stato = { id: 1, codice: "N", descrizione: "Nuovo" };
        this.brogliaccioCorrente.dataCreazione = new Date();

        //INSERIMENTO
        this._brogliacciService.insert(this.brogliaccioCorrente)
          .finally(() => this.saving = false)
          .subscribe(
            (data: any) => {
              //verifica esito e redirect al dettaglio
              if (data.result.result === false) {
                this.showError(data.result.message);
                return false;
              } else
                if (data.tokenBrogliaccio === "") {
                  this.showError("Errore durante la procedura di creazione del brogliaccio");
                  return false;
                } else {
                  this.showInfo("Salvataggio avvenuto con successo");
                  this.router.navigateByUrl('/brogliacci/' + data.tokenBrogliaccio);
                }
            },
            error => {
              this.showError("Errore durante la procedura di creazione del brogliaccio");
              return false;
            }
          );


      }
    }
  }


  private showError(msg: string) {
    this.snackBar.open(msg, 'Chiudi', { duration: 4000 });
  }

  private showInfo(msg: string) {
    this.snackBar.open(msg, 'Chiudi', { duration: 2000 });
  }
}



/***************************** */
/* DATA SOURCE - lista incassi */
export class IncassiDaRendicontare extends DataSource<any> {
  incassi: Observable<IncassoModel[]>;

  constructor(private data: IncassoModel[], private _paginator: MdPaginator) {
    super();
  }

  connect(): Observable<IncassoModel[]> {
    this.incassi = Observable.of(this.data);
    //this.incassi = this._incassiService.getListDaRendicontare();
    return this.incassi;
  }
  disconnect() { }

}

export class DataSourceZone extends DataSource<any> {
  zoneTotali:Observable<any[]>;
  constructor(private data:any[]) {
    super();
  }
  connect():Observable<any[]> {
    this.zoneTotali=Observable.of(this.data);
    return this.zoneTotali;
  }
  disconnect() {

  }
}




// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/brogliacci/brogliaccio-new-detail.component.ts